import { injectIntl, IntlShape } from '@liveauctioneers/hammer-ui-core/intl';
import { TextInput } from '@liveauctioneers/hammer-ui-core/textInput';
import * as React from 'react';
import isEqual from 'react-fast-compare';

type Form = {
    fieldErrors: any;
    fieldValid: any;
};

type Props = {
    [x: string]: any;
    autoComplete?: string;
    form: Form;
    id: string;
    intl: IntlShape;
} & React.ComponentProps<typeof TextInput>;

// This is intentionally a class component because the combination of memo and fast compare causes BUGS-1682
class FormInput extends React.Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const { autoComplete, form, id, intl, ...rest } = this.props;
        const { fieldErrors, fieldValid } = form;
        const { formatMessage } = intl;

        return (
            <TextInput
                {...rest}
                aria-label={formatMessage({ id: `formLabels.${id}` })}
                autoComplete={autoComplete}
                errorText={fieldErrors[id] ? String(formatMessage({ id: fieldErrors[id] })) : undefined}
                hasError={!fieldValid[id]}
                id={id}
                labelText={formatMessage({ id: `formLabels.${id}` })}
            />
        );
    }
}

export default injectIntl(FormInput);
